<template>
  <div class="disclaimer" :class="[disclaimerClass, clampClass]">
    <span><div class="disclaimer__icon" :class="iconClass"></div></span>
    <ul class="disclaimer__wrapper">
      <li v-for="(val, key, index) of disclaimerTexts" :key="index">
        <p v-if="!!link" class="disclaimer__text">
          {{ val }}
          <a v-if="key == Object.keys(disclaimerTexts).length - 1" :href="link.href" class="formulate-input-link" target="_blank">
            {{ link.text }}</a
          >
        </p>
        <p v-else class="disclaimer__text" v-html="val"></p>
      </li>
    </ul>
    <div v-if="isTextClamped" class="disclaimer__dropdown-icon" @click="toggleClamp">
      <div class="icon icon-arrow" :class="{ 'icon-arrow--open': !clamped }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      clamped: true,
    };
  },
  computed: {
    disclaimerTexts() {
      return this.context.slotProps.component.settings.disclaimerTexts;
    },
    link() {
      return this.context.slotProps.component.settings.link || '';
    },
    iconClass() {
      return this.context.slotProps.component.settings.icon || '';
    },
    isTextClamped() {
      return this.context.slotProps.component.settings.shouldClampText || false;
    },
    disclaimerClass() {
      return this.context.slotProps.component.settings.isWarning ? 'disclaimer--warning' : 'disclaimer--info';
    },
    clampClass() {
      return this.isTextClamped && this.clamped ? 'disclaimer--clamped' : '';
    },
  },
  methods: {
    toggleClamp() {
      this.clamped = !this.clamped;
    },
  },
};
</script>
